import { Component, Input } from '@angular/core';
import { PopupFieldData } from 'src/app/features/designer-studio/edit-pdf-doc/models/doc.model';

@Component({
  selector: 'app-screen-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss']
})
export class ButtonComponent  {
  @Input() initOptions: PopupFieldData;
}
